import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../Hoot";
import { toast } from "react-toastify";
import RegisterOrUpdateContactModal from "./Modals/RegisterOrUpdateContactModal";
import { Tabs, Tab } from "react-bootstrap";
import { FiEdit3 } from "react-icons/fi";
import { LuScanEye } from "react-icons/lu";

/* ===============================
🔥 EXACT SaaS STYLE
=============================== */

const css = `
:root{
--bg:#f3f5fb;
--card:#ffffff;
--border:#e4e7ef;
--text:#0f172a;
--muted:#6b7280;
--purple:#6366f1;
}

/* PAGE */

.page{
background:var(--bg);
padding:28px;
min-height:100vh;
}

/* CONTAINER */

.container-box{
background:var(--card);
border-radius:26px;
padding:26px;
box-shadow:0 30px 80px rgba(15,23,42,.05);
}

/* HEADER */

.header{
display:flex;
justify-content:space-between;
align-items:center;
}

.title{
font-size:24px;
font-weight:700;
}

.counter{
margin-left:10px;
background:#eef2ff;
color:#4338ca;
padding:6px 14px;
border-radius:999px;
font-weight:600;
}

/* BUTTONS */

.btn{
border-radius:999px;
padding:8px 16px;
font-weight:600;
border:1px solid var(--border);
background:#fff;
cursor:pointer;
}

.btn-primary{
background:linear-gradient(135deg,#6366f1,#4f46e5);
color:#fff;
border:none;
}

/* FILTER BOX */

.filters{
margin-top:20px;
padding:18px;
border-radius:18px;
background:linear-gradient(180deg,#f9fbff,#f1f4fa);
border:1px solid var(--border);
display:flex;
gap:12px;
flex-wrap:wrap;
}

.input,.select{
border-radius:10px;
border:1px solid var(--border);
padding:10px;
min-width:220px;
}

/* KPI */

.kpis{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(190px,1fr));
gap:18px;
margin:24px 0;
}

.kpi{
position:relative;
padding:20px;
border-radius:20px;
background:linear-gradient(135deg,#ffffff,#f7f9ff);
border:1px solid var(--border);
overflow:hidden;
}

.kpi::after{
content:"";
position:absolute;
width:120px;
height:120px;
border-radius:50%;
background:radial-gradient(circle,#6366f122,transparent);
right:-30px;
top:-30px;
}

.kpi h2{
margin:0;
font-weight:800;
}

.kpi span{
color:var(--muted);
}

/* TABS */

.nav-tabs{
border:none;
margin-bottom:10px;
}

.nav-tabs .nav-link.active{
background:linear-gradient(135deg,#6366f1,#4f46e5);
color:#fff !important;
border:none;
border-radius:10px;
}

/* TABLE */

.table{
margin-top:10px;
border-top:1px solid var(--border);
}

.thead,.row{
display:grid;
grid-template-columns: 3fr 1fr 1fr 1fr 1.5fr 1fr;
align-items:center;
padding:16px;
}

.thead{
color:#64748b;
font-weight:700;
}

.row{
border-top:1px solid var(--border);
transition:.15s;
}

.row:hover{
background:#fafbff;
}

/* INSTITUTION */

.inst{
display:flex;
align-items:center;
gap:12px;
}

.avatar{
width:44px;
height:44px;
border-radius:12px;
background:linear-gradient(135deg,#22c55e,#16a34a);
color:#fff;
display:flex;
align-items:center;
justify-content:center;
font-weight:700;
}

/* BADGES */

.badge{
padding:6px 14px;
border-radius:999px;
font-weight:600;
font-size:13px;
}

.blue{
background:#e0e7ff;
color:#3730a3;
}

.orange{
background:#ffedd5;
color:#9a3412;
}

.red{
background:#fee2e2;
color:#b91c1c;
}

/* COMMERCIAL */

.commercial{
display:flex;
align-items:center;
gap:8px;
}

.mini{
width:34px;
height:34px;
border-radius:10px;
background:#7c3aed;
color:#fff;
display:flex;
align-items:center;
justify-content:center;
font-weight:700;
}

/* ACTIONS */

.actions{
display:flex;
gap:8px;
}

.icon{
width:36px;
height:36px;
border-radius:10px;
border:1px solid var(--border);
background:#fff;
display:flex;
align-items:center;
justify-content:center;
cursor:pointer;
}

/* PAGINATION */

.pagination{
margin-top:20px;
display:flex;
gap:6px;
}

.page-btn{
border:none;
padding:7px 12px;
border-radius:8px;
background:#eef2ff;
cursor:pointer;
}

.active-page{
background:#6366f1;
color:#fff;
}
`;

/* ===============================
UTILS
=============================== */

const normalize = s =>
s?.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase() || "";

const initial = n => n?.charAt(0)?.toUpperCase() || "?";

/* ===============================
COMPONENT
=============================== */

export default function ContactsListTable(){

const [contacts,setContacts] = useState([]);
const [user,setUser] = useState(null);
const [search,setSearch] = useState("");
const [tab,setTab] = useState("list");
const [page,setPage] = useState(1);

const perPage = 10;

/* LOAD */

useEffect(()=>{loadUser()},[]);

async function loadUser(){
try{
const res = await axios.get(Hoot()+"me",{withCredentials:true});
setUser(res.data);
loadContacts();
}
catch{
toast.error("Erro ao carregar utilizador");
}
}

async function loadContacts(){
try{
const res = await axios.get(
Hoot()+"contacts/shared-with-me",
{withCredentials:true}
);
setContacts(res.data.data || []);
}
catch{
toast.error("Erro ao carregar contactos");
}
}

/* FILTER */

const filtered = useMemo(()=>{
const s = normalize(search);
return contacts.filter(c =>
normalize(c.ed_contact_name).includes(s)
);
},[contacts,search]);

/* KPI */

const kpis = {
total:filtered.length,
parados:filtered.filter(c=>normalize(c.ed_contact_status).includes("parado")).length
};

/* PAGINATION */

const pages = Math.ceil(filtered.length/perPage);

const data = filtered.slice(
(page-1)*perPage,
page*perPage
);

return(
<>
<style>{css}</style>

<div className="page">
<div className="container-box">

{/* HEADER */}

<div className="header">
<div>
<span className="title">Contactos</span>
<span className="counter">{filtered.length} contactos</span>
</div>

<div style={{display:"flex",gap:10}}>
{user?.charge !== "visitor" && (
<RegisterOrUpdateContactModal
toggle_btn={
<button className="btn btn-primary">
+ Adicionar contacto
</button>
}
/>
)}

<button className="btn" onClick={loadContacts}>
Recarregar
</button>
</div>
</div>

{/* FILTERS */}

<div className="filters">

<input
className="input"
placeholder="Pesquisar por instituição..."
value={search}
onChange={(e)=>{
setSearch(e.target.value);
setPage(1);
}}
/>

<select className="select">
<option>Todos os comerciais</option>
</select>

<select className="select">
<option>Todos os estados</option>
</select>

<select className="select">
<option>Todas as províncias</option>
</select>

</div>

{/* KPI */}

<div className="kpis">

<div className="kpi">
<h2>{kpis.total}</h2>
<span>Total (filtro)</span>
</div>

<div className="kpi">
<h2>{kpis.parados}</h2>
<span>Parados</span>
</div>

</div>

{/* TABS */}

<Tabs activeKey={tab} onSelect={setTab}>
<Tab eventKey="list" title="Listagem de contactos">

<div className="table">

<div className="thead">
<div>Instituição</div>
<div>Tipo</div>
<div>Estado</div>
<div>Província</div>
<div>Comercial</div>
<div>Ação</div>
</div>

{data.map(c=>(

<div key={c.ed_contact_id} className="row">

<div className="inst">
<div className="avatar">
{initial(c.ed_contact_name)}
</div>

<div>
<div style={{fontWeight:600}}>
{c.ed_contact_name}
</div>
<div style={{color:"#64748b",fontSize:13}}>
{c.ed_contact_phone}
</div>
</div>
</div>

<div>
<span className="badge blue">Colégio</span>
</div>

<div>
<span className="badge red">
{c.ed_contact_status}
</span>
</div>

<div>
<span className="badge">
huila
</span>
</div>

<div className="commercial">
<div className="mini">S</div>
<div>
<div style={{fontWeight:600}}>Comercial</div>
<div style={{fontSize:12,color:"#64748b"}}>huila</div>
</div>
</div>

<div className="actions">

<button className="icon">
<LuScanEye/>
</button>

{user?.charge !== "visitor" && (
<RegisterOrUpdateContactModal
contactId={c.ed_contact_id}
update
toggle_btn={
<button className="icon">
<FiEdit3/>
</button>
}
/>
)}

</div>

</div>

))}

<div className="pagination">
{Array.from({length:pages}).map((_,i)=>(
<button
key={i}
onClick={()=>setPage(i+1)}
className={`page-btn ${page===i+1?"active-page":""}`}
>
{i+1}
</button>
))}
</div>

</div>

</Tab>

<Tab eventKey="analytics" title="Análise de desempenho"/>
</Tabs>

</div>
</div>
</>
);
}
